<div
  class="flex h-12 overflow-hidden rounded-md bg-black/10 p-2 shadow-[inset_0_1px_2px_rgba(0,0,0,0.2)]"
>
  @let progressBarClasses =
    'flex items-center justify-center text-white h-full text-base transition-[width] duration-1000 ease-in-out min-w-[20%] w-0';
  <div
    class="{{ progressBarClasses }} bg-[#0D62FF] rounded-tl-sm rounded-bl-sm"
    [ngStyle]="{ width: inServicePercentage + '%' }"
  >
    <span class="mr-1 text-2xl">{{ inService }}</span> In Service
  </div>
  <div
    class="{{ progressBarClasses }} rounded-tr-sm rounded-br-sm bg-black/40"
    [ngStyle]="{ width: pendingPercentage + '%' }"
  >
    <span class="mr-1 text-2xl">{{ pending }}</span> Pending
  </div>
</div>
